export enum MeetingKey {
  MEETINGS = 'meetings',
  MEETINGS_INFINITE = 'meetingsInfinite',
}
